<template>
  <v-number-input
    data-test-id="numericField"
    style="margin-bottom: 1rem"
    v-maska="_mask"
    v-bind="$attrs"
    v-model="model"
    color="primary"
    variant="underlined"
    control-variant="default"
    inset
    :required="required"
    :min="min"
    :max="max"
    :rules="getRules()"
  >
    <template v-slot:increment></template>
    <template v-slot:decrement></template>
    <template v-slot:label>
      <span>{{ label }}&nbsp;<span v-if="required" class="required-text">*</span></span>
    </template>
  </v-number-input>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { useRulesManager } from '@/composables/RulesManager'
import { isDefined } from '@/composables/utils'
import { Rule } from '@/enums/Rule'
import { onMounted, ref, watch } from 'vue'

const RulesManager = useRulesManager()

// PROPS & EMITS
const props = defineProps({
  label: { type: String, default: '' },
  mask: { type: String },
  min: { type: Number, default: Number.MAX_SAFE_INTEGER },
  max: { type: Number, default: Number.MAX_SAFE_INTEGER },
  required: { type: Boolean, default: false }
})

// REACTIVE VARIABLES
const _mask = ref<string>()
const model = defineModel<number | null | undefined>({ default: 0 })

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS
onMounted(() => {
  if (props.mask) {
    _mask.value = props.mask
  } else if (props.max) {
    _mask.value = '#'.repeat(props.max.toString().length)
  }
})

// WATCHERS
watch(
  (): any => model.value,
  (newValue, oldValue) => {
    if (!isDefined(newValue) && props.required) {
      model.value = oldValue
    }
  }
)

// FUNCTIONS
const getRules = (): any => {
  let rules = RulesManager.getRules({
    key: Rule.ValidNumber,
    payload: {
      min: props.min,
      max: props.max
    }
  })
  if (props.required) {
    rules = rules.concat(RulesManager.getRules(Rule.Required))
  }
  return rules
}
</script>
